const isProd = process.env.VUE_APP_ENV === 'production';

export const BASE_URL = `https://${isProd ? 'amarkets.cards' : 'acard-front.stage.amarkets.dev'}`;

export const ALL_TRANSACTIONS = `${BASE_URL}/all-transactions/`;
